import { render, staticRenderFns } from "./uf_region_id.vue?vue&type=template&id=2abbd858&scoped=true"
import script from "./uf_region_id.vue?vue&type=script&lang=js"
export * from "./uf_region_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbd858",
  null
  
)

export default component.exports